var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('MapCrudFormComponent',{attrs:{"poi":_vm.formData,"submited":_vm.submited},on:{"mapCrudFormEvent":_vm.save,"resetSubmit":_vm.resetSubmit}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }